<app-page>
    <app-order [orderId]="orderId"></app-order>
</app-page>
